import styled from 'styled-components';

import { Text } from '@gympass/yoga';
import { AlertCircle } from '@gympass/yoga-icons';

export const Container = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.small}px;
  width: 100%;
  background-color: ${({ theme }) => theme.yoga.colors.disabled};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;

  display: flex;
  align-items: center;
`;

export const StyledAlertCircle = styled(AlertCircle).attrs({
  width: '20',
  height: '20',
})``;

export const InfoText = styled(Text.Light)`
  flex: 1;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const InfoStrong = styled(Text.Medium).attrs({
  as: 'a',
  href: 'mailto:atendimento@wellz.com',
  rel: 'noreferrer',
  target: '_blank',
})`
  color: ${({ theme }) => theme.yoga.colors.primary};
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  display: inline-block;

  &:not(:hover) {
    text-decoration: underline;
  }
`;
